var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Prevent expensive, repeat function calls by caching the result and returning
 * the cached result when the cacheKey matches
 *
 * The cache key must be toString-able.
 * The cache key will automatically default to the first argument of the memoized function,
 * otherwise the cacheKeyGenerator can be used.
 * The cacheKeyGenerator must be used when the first argument is an object, otherwise the
 * cacheKey will be converted to '[object Object]' which could provided unexpected results
 *
 * @param {(...args: any[]) => any} fn The function to memoize
 * @param {(...args: any[]) => string} [cacheKeyGenerator] Optional. Arguments passed in are supplied by the function to be memoized
 * @return {(...args: any[]) => any}
 */
export var memoize = function (fn, cacheKeyGenerator) {
    var cache = {};
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheKey = (_a = (cacheKeyGenerator ? cacheKeyGenerator.apply(void 0, __spread(args)) : args[0])) === null || _a === void 0 ? void 0 : _a.toString();
        if (!(cacheKey in cache)) {
            cache[cacheKey] = fn.apply(void 0, __spread(args));
        }
        return cache[cacheKey];
    };
};
//# sourceMappingURL=memoize.js.map